export const FlexGroupType = {
    Default: 0,
    Shared: 1
} as const;

export type FlexGroupType = typeof FlexGroupType[keyof typeof FlexGroupType];